// extracted by mini-css-extract-plugin
module.exports = {"container":"routes_container__3E92B"};